import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzRating',
  props: {
    score: {
      default: function _default() {
        return 0;
      }
    },
    max: {
      default: function _default() {
        return 5;
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var roundedScore = computed(function () {
      return Math.abs(Math.ceil(props.score)) || 0;
    });
    var negativeNumber = computed(function () {
      return Math.abs(props.max) - roundedScore.value;
    });
    return {
      __sfc: true,
      props: props,
      i18n: i18n,
      roundedScore: roundedScore,
      negativeNumber: negativeNumber
    };
  }
});